import React, { useEffect, useState, useRef } from "react";
import "croppie/croppie.css";
import { IconButton, LinearProgress, Button, Popper, withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import MuiSlider from "@material-ui/core/Slider";
import axios from "axios";
import { calculateImageSize } from "../../helpers/imageHelper";
import { usePrevious } from "../../cms_2.0/helpers/usePrevious";
import {CustomIcon} from '../../cms_2.0/components/CustomIcon'
import { securityHelper } from "../../helpers/securityHelper";
import { handleResponse } from "../../helpers/handleresponse";
import { authHeader } from "../../helpers/authHeader";
const Slider = withStyles({
  root: {
    color: "var(--primary-color)",
    height: 4,
  },
  thumb: {
    height: 12,
    width: 12,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -4,
    marginLeft: -6,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 4,
    borderRadius: 4,
  },
  rail: {
    height: 4,
    borderRadius: 4,
  },
})(MuiSlider);

const Croppie = require("croppie");

export const Cropper = (props) => {
  const [zoom, setZoom] = useState(0);
  const [filled, setFilled] = useState(false);
  const [shape, setShape] = useState("normal");
  const [isLoading, setIsLoading] = useState(false);

  const { hideOverlay, size, source, isCropping, parentId, wrapperRef, onCropped, viewport, eventId, toggle } = props;

  const prevProps = usePrevious();
  const cropper = useRef();
  const suffix = +Date.now();

  useEffect(() => {
    init();
  }, []);
  useEffect(() => {
    init();
  }, [filled]);
  useEffect(() => {
    init();
  }, [shape]);

  useEffect(() => {
    if (prevProps && hideOverlay !== undefined && prevProps.hideOverlay !== hideOverlay && hideOverlay == false) {
      init(true);
    }
    if (prevProps && source !== undefined && prevProps.source !== source) {
      init();
    }
    if (prevProps && isCropping !== isCropping) {
      init();
    }
  }, [isCropping, source, hideOverlay]);

  const init = (reRender = false) => {
    const { size, parentId, viewport, backgroundColor } = props;

    if (cropper.current) {
      cropper.current.destroy();
    }
    if (size !== null || reRender) {
      cropper.current = new Croppie(document.getElementById("croppie-img-" + parentId), {
        viewport:
          filled || shape == "circle"
            ? shape == "circle"
              ? {
                  ...viewport,
                  height: shape == "circle" && viewport.height > viewport.width ? size.width : size.height,
                  width: shape == "circle" && viewport.height > viewport.width ? size.width : size.height,
                  type: shape,
                }
              : {
                  ...viewport,
                }
            : { ...size, type: shape },
        boundary:
          shape == "circle"
            ? {
                height: shape == "circle" && viewport.height > viewport.width ? size.width : size.height,
                width: shape == "circle" && viewport.height > viewport.width ? size.width : size.height,
              }
            : viewport,
        showZoomer: false,
        type: "base64",
        enableOrientation: true,
      });

      handleZoomOut(0);
      let listNodes = document.getElementsByClassName("cr-vp-square");

      if (listNodes[0]) {
        listNodes[0].style.boxShadow = `0px 0px 2000px 2000px ${backgroundColor}`;
      }
      listNodes = document.getElementsByClassName("cr-vp-circle");
      if (listNodes[0]) {
        listNodes[0].style.boxShadow = `0px 0px 2000px 2000px ${backgroundColor}`;
      }
    }
  };

  const handleZoomOut = (scale, controlled = false) => {
    if (cropper.current) {
      const cZoom = cropper.current.get().zoom;
      if (!controlled && scale === 0) {
        setZoom(scale);
        cropper.current.setZoom(scale);
        return;
      }
      if (controlled === true && scale !== undefined) {
        setZoom(scale);
        cropper.current.setZoom(scale);
        return;
      }
      if (cZoom !== zoom) {
        if (cZoom === 50) {
          setZoom(0);
          cropper.current.setZoom(0);
          return;
        }
        setZoom(zoom);
      }
    }
  };
  const handleResult = () => {
    setIsLoading(true);
    if (shape == "circle") {
      return cropper.current
        .result({
          type: "base64",
          size: { height: shape == "circle" && viewport.height > viewport.width ? size.width : size.height, width: shape == "circle" && viewport.height > viewport.width ? size.width : size.height },
        })
        .then((res) => handleSave(res));
    }
    cropper.current.result({ type: "base64", size: filled && shape != "circle" ? viewport * 4 : size }).then((res) => handleSave(res));
  };
  const handleSave = (res) => {
    const fileInfo = {
      name: "cropped-" + securityHelper.createGuid(),
      size: calculateImageSize(res).inBytes,
      type: "image/png",
      file: res,
      isCropped: true,
    };
    const requestOptions = {
      method: "POST",
      headers: authHeader({ "Content-Type": "application/json" }),
      body: JSON.stringify(fileInfo),
    };
    fetch(`./api/files/`, requestOptions)
      .then(handleResponse)
      .then((file) => {

        props.onSave(file.url);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });

  };
  const rotate = () => cropper.current.rotate(90);

  return (
    <>
      {isLoading ? <LinearProgress /> : null}
      <div
        id="inline-croppie-overlay"
        onWheel={handleZoomOut}
        className="inline-croppie-overlay"
        style={{ width: "100%", paddingBottom: 30, position: "relative", display: "flex", flexDirection: "column-reverse" }}
      >
        {source && source.startsWith("http") ? (
          <img crossOrigin="anonymous" id={`croppie-img-${parentId}`} src={source + `?rndparam=${suffix}`} />
        ) : (
          <img id={`croppie-img-${parentId}`} src={source} />
        )}

        <Popper style={{ zIndex: 1000 }} id={+new Date()} open={true} anchorEl={props.wrapperRef?.current} style={{ marginLeft: "-70px", marginTop: "80px", zIndex: 1000 }}>
          <div className={`croppie-controllers-2 pi-crop`} style={{ width: "500px" }}>
            <Grid container spacing={2} style={{ alignItems: "center" }}>
              <Grid className="flex" item>
                <CustomIcon name="ZOOMOUT"/>
              </Grid>
              <Grid className="flex" item xs>
                <Slider value={zoom} min={0} max={2} step={0.1} onChange={(event, newValue) => handleZoomOut(newValue, true)} aria-labelledby="zoom-slider" />
              </Grid>
              <Grid className="flex" item>
                <CustomIcon name="ZOOMIN"  />
              </Grid>
              <Grid item>
                <IconButton style={{ padding: "0px 10px" }} onClick={rotate}>
                  <CustomIcon name="ROTATE" tooltip="RotateImage" />
                </IconButton>
                <IconButton style={{ padding: "0px 10px" }} onClick={() => setFilled(!filled)}>
                  {!filled ? <CustomIcon name="FULL_SIZE" tooltip="FullSizeImage"  /> : <CustomIcon name="ASPECT_RATIO" tooltip="KeepRatio"  />}
                </IconButton>
                {filled ? (
                  <IconButton style={{ padding: "0px 10px" }} onClick={() => setShape(shape == "circle" ? "normal" : "circle")}>
                    {shape != "circle" ? <CustomIcon name="CIRCLE" tooltip="CircularShape"  /> : <CustomIcon name="NORMAL_SHAPE" tooltip="NormalShape"  />}
                  </IconButton>
                ) : null}
                <IconButton style={{ padding: "0px 10px" }} onClick={handleResult}>
                  <CustomIcon name="CHECK" tooltip="SaveChanges"  />
                </IconButton>
                <IconButton style={{ padding: "0px 10px" }} onClick={toggle}>
                  <CustomIcon name="CLOSE" tooltip="Cancel" />
                </IconButton>
              </Grid>
            </Grid>
          </div>
        </Popper>
      </div>
    </>
  );
};
